import { render } from "./footer.vue?vue&type=template&id=029e7059&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=029e7059&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/kj-wx-web-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029e7059"]])

export default __exports__